// -------------- REPORT Page --------------
export const POS_SET_ALL        = 'POS_SET_ALL';
export const TECHNICIAN_SET_ALL = 'TECHNICIAN_SET_ALL';
export const CITY_SET_ALL       = 'CITY_SET_ALL';
export const RATE_SET_ALL       = 'RATE_SET_ALL';



// --------- REPORT Page ---------
export function postSetList(all) {
    return { type: POS_SET_ALL, data: all }
}
export function technicianSetList(all) {
    return { type: TECHNICIAN_SET_ALL, data: all }
}
export function citySetList(all) {
    return { type: CITY_SET_ALL, data: all }
}
export function rateSetList(all) {
    return { type: RATE_SET_ALL, data: all }
}
